import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import RoomWizard from "@/pages/RoomWizard";
import RoomManage from "@/pages/RoomManage";
import PublicRoom from "@/pages/PublicRoom";
import AdminPage from "@/pages/AdminPage";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center text-slate-400">Načítání…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App bg-[#0B0F17] text-slate-50">
      <AuthProvider>
        <I18nProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<AuthPage mode="login" />} />
              <Route path="/register" element={<AuthPage mode="register" />} />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/rooms/new" element={<Protected><RoomWizard /></Protected>} />
              <Route path="/rooms/:id/manage" element={<Protected><RoomManage /></Protected>} />
              <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
              <Route path="/r/*" element={<PublicRoom />} />
              <Route path="*" element={<PublicRoom />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </I18nProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
